module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-home-latest"
  }, [_c('ForumThreadList', {
    ref: "threadList",
    staticClass: "thread-list",
    attrs: {
      "sortable": true,
      "sort-order": _vm.sortOrder,
      "threads": _vm.threads
    },
    on: {
      "update:sort-order": function($event) {
        _vm.$emit('update:sort-order', $event)
      }
    }
  }), _vm._v(" "), (_vm.canLoadMoreThreads) ? _c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingThreads),
      expression: "loadingThreads"
    }]
  }) : _vm._e(), _vm._v(" "), (!_vm.canLoadMoreThreads) ? _c('div', {
    staticClass: "after-threads-msg"
  }, [_vm._v("\n        That's all, folks!\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2fa6fa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumHomeLatest.vue
// module id = 2142
// module chunks = 2